export const JOBS = {
  REVIEW_KEYWORD: 'user-alert-review-keyword',
  RATING_CATEGORY_SCORE_CHANGE: 'user-alert-rating-category-score-change',
  STATION_PROFILE_PDF: 'user-pdf-station-profile-report',
  STATION_REVIEWS_PDF: 'user-pdf-station-reviews-report',
  STATION_RATINGS_PDF: 'user-pdf-station-ratings-report',
  BRAND_ENGAGEMENT_PDF: 'user-pdf-brand-engagement-report',
  COMPETITOR_BENCHMARK_PDF: 'user-pdf-competitor-benchmarking-report',
};

export const SENTIMENT = {
  POSITIVE: 'Positive',
  NEUTRAL: 'Neutral',
  NEGATIVE: 'Negative',
};

export const getSentimentDisplayValue = (sentiment) => {
  switch (sentiment) {
    case SENTIMENT.POSITIVE.toLowerCase():
      return SENTIMENT.POSITIVE;
    case SENTIMENT.NEUTRAL.toLowerCase():
      return SENTIMENT.NEUTRAL;
    case SENTIMENT.NEGATIVE.toLowerCase():
      return SENTIMENT.NEGATIVE;
    default:
      return '';
  }
};

export const STATUS = {
  GOOD: 'good',
  AVERAGE: 'average',
  POOR: 'poor',
  NOT_RATED: 'none',
};

export const STATUS_NAME = {
  [STATUS.GOOD]: 'Top Rated',
  [STATUS.AVERAGE]: 'Average',
  [STATUS.POOR]: 'Needs Work',
  [STATUS.NOT_RATED]: 'Not Rated',
};

export const ORIGINAL_STATUSES = [
  STATUS.GOOD,
  STATUS.AVERAGE,
  STATUS.POOR,
  STATUS.NOT_RATED,
];

export const CHANGED_STATUSES = [STATUS.GOOD, STATUS.AVERAGE, STATUS.POOR];

export const convertStatusToDisplayName = status => STATUS_NAME[status];
